import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { toast } from "sonner";

export function OfflineBanner() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && navigator.onLine === false);

  useEffect(() => {
    const goOnline = () => { setOffline(false); toast.success("Back online — you're reconnected."); };
    const goOffline = () => setOffline(true);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (!offline) return null;
  return (
    <div data-testid="offline-banner"
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 bg-[#F04438] px-4 py-2 text-center text-sm font-semibold text-white shadow-lg">
      <WifiOff size={15} /> You're offline — changes will sync when the connection returns.
    </div>
  );
}
